import { createSearchBehavior, searchView } from "./search-behavior";

export default function searchBox({main, on, elm, state}) {
	const search = createSearchBehavior({
		elm,
		state,
		inputSelector: '[data-search-input]'
	});

	elm.focusSearch = search.focusInput;
	elm.resetSearch = search.reset;

	main(() => {
		on('input', '[data-search-input]', search.handleInput);
		on('submit', '[data-search-form]', search.submit);
	});
}

export const model = {};

export const view = searchView;
